// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_a7fca {
  padding : 0 0;

  .settingsHeader_EVd4L {
    border-bottom: 5px solid var( --background );
    padding: 10px 26px 10px 10px;
  }
  
}`, "",{"version":3,"sources":["webpack://./src/screens/project/settings.css"],"names":[],"mappings":"AAEA;EACE,aAAa;;EAEb;IACE,4CAA4C;IAC5C,4BAA4B;EAC9B;;AAEF","sourcesContent":["@import \"../../style/theme.css\";\n\n.content {\n  padding : 0 0;\n\n  .settingsHeader {\n    border-bottom: 5px solid var( --background );\n    padding: 10px 26px 10px 10px;\n  }\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_a7fca`,
	"settingsHeader": `settingsHeader_EVd4L`
};
export default ___CSS_LOADER_EXPORT___;
